module.exports = __webpack_public_path__ + "img/yaourt.dbf29098.png";